import GraphQL from "../../api/graphql";
import { make } from "vuex-pathify";
import differenceInMinutes from "date-fns/differenceInMinutes";
import { AuthenticationError } from "../../api/errors";
import isEmpty from "lodash/isEmpty";

const state = {
    access_token: "",
    last_updated_at: new Date()
};

const mutations = make.mutations(state);

const actions = {
    async login({ dispatch }, { email, password }) {
        const client = new GraphQL();

        const response = await client.query({
            query: `
                mutation(
                        $email: String!
                        $password: String!
                    ) {
                        login(email: $email, password: $password) {
                            access_token
                        }
                }
            `,
            variables: {
                email,
                password
            }
        });

        const { access_token: accessToken } = response.data.login;

        this.set("auth/access_token", accessToken);
        this.set("auth/last_updated_at", new Date());

        await dispatch("user/fetch", {}, { root: true });
        await dispatch("search/reset", {}, { root: true });
        await dispatch("users/fetch", {}, { root: true });
    },
    async refresh({ state }) {
        const client = new GraphQL({
            headers: {
                Authorization: `Bearer ${state.access_token}`
            }
        });

        const response = await client.query({
            query: `mutation {
                refreshLogin {
                    access_token
                }
            }`,
            variables: {}
        });

        const { access_token: accessToken } = response.data.refreshLogin;

        this.set("auth/access_token", accessToken);
        this.set("auth/last_updated_at", new Date());
    },
    async validateToken({ state, dispatch }) {
        if (
            state.last_updated_at === undefined ||
            isEmpty(state.last_updated_at)
        ) {
            this.set("auth/last_updated_at", new Date().toString());
        }

        const minutesSinceLastRefresh = differenceInMinutes(
            new Date(),
            new Date(state.last_updated_at)
        );

        const shouldRefreshToken = minutesSinceLastRefresh >= 30;

        if (!shouldRefreshToken) {
            return;
        }

        console.warn("System will update your token..");

        try {
            await dispatch("refresh");
            await dispatch("user/fetch", {}, { root: true });
        } catch (error) {
            if (error instanceof AuthenticationError) {
                await dispatch("auth/logout");
                throw error;
            } else {
                throw new Error("Cannot fetch user information");
            }
        }
    },
    reset() {
        this.set("auth/access_token", "");
        this.set("auth/last_updated_at", null);
    },
    logout({ dispatch }) {
        dispatch("reset");
        dispatch("document/reset", {}, { root: true });
        dispatch("favoriteSearches/reset", {}, { root: true });
        dispatch("manageDocuments/reset", {}, { root: true });
        dispatch("search/reset", {}, { root: true });
        dispatch("user/reset", {}, { root: true });
        dispatch("users/reset", {}, { root: true });
        dispatch("menu/reset", {}, { root: true });
    }
};

export default { state, mutations, actions };
